import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { query, paginate } from '../../lib/loopback'

const logFlexRepository = createRepository({
  path: 'log-flex',
  restApi,
  queryTransform: {
    consulta: query.ilikeWithoutSplit('consulta'),
    dataInicio: query.gte('dataInicio'),
    dataFim: query.lte('dataFim'),
    ...paginate
  }
})

export default logFlexRepository
